<!--
For other possible props for a-form:
@see https://2x.antdv.com/components/form
-->

<template>
  <a-form
    ref="formRef"
    hideRequiredMark
    :colon="false"
    :wrapper-col="{ span: 12 }"
    :label-col="{ span: 12 }"
    :validateTrigger="validateTrigger"
    v-bind="$attrs"
    @submit="onSubmit"
    autocorrect="disabled"
    autocapitalize="disabled"
    spellcheck="false"
    :scrollToFirstError="scrollToFirstError"
    v-form-loading="loading || disabled"
  >
    <slot></slot>
  </a-form>
</template>

<style lang="scss"></style>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const validateTrigger = ref("submit");
    const formRef = ref();

    return {
      formRef,
      validateTrigger,
      onSubmit(e) {
        /**
         * change validation trigger to change on initial submit
         * so it will validate when value changes
         */
        validateTrigger.value = "change";

        /**
         * emit original submit on submit with event
         */
        emit("submit", e);
      },
      scrollToFirstError: {
        behavior: (actions) => {
          actions.forEach(({ el, top }) => {
            /**
             * Add header height + 40 on top el to scroll
             */
            const headerHeight =
              document.querySelector("header")?.clientHeight || 50;
            const extraOffset = 40;

            el.scrollTop = top - (headerHeight + extraOffset);
          });
        },
      },
    };
  },
});
</script>
